import { FirebaseError } from "firebase/app";
import { FIREBASE_TRANSLATE_ERRORS } from "./contants";

export const getTranslatedErrorMessage = (error: FirebaseError) => {

    const translatedMessage = FIREBASE_TRANSLATE_ERRORS[error.code] || error.message || FIREBASE_TRANSLATE_ERRORS.unknown;

    return new FirebaseError(error.code, translatedMessage);
};